import React from 'react'
import { observer, inject } from 'mobx-react'
import LoadingComponent from '../../../LoadingComponent'
import { Link } from 'react-router'
import { append } from '../../../../utils/url'
import { formatDate } from '../../../../utils/format'
import Icon from '../../../util/Icon'
import DropdownMenu from '../../../navigation/DropdownMenu'
import OrderableTH from '../../../navigation/OrderableTH'
import StorePagination from '../../../navigation/StorePagination'
import classnames from 'classnames'

@inject('websites', 'recommended_listings')
@observer
export default class RecommendedListings extends LoadingComponent {
  website = this.props.websites.current

  state = {
    order_by: 'created_at',
    order_dir: 'desc'
  }

  hasLoaded() {
    return this.props.recommended_listings.loaded
  }

  loadPage(nextPage) {
    const { page=1 } = this.props.location.query
    this.props.recommended_listings.loadPage(nextPage || page, this.state)
  }

  componentWillMount() {
    const { order_by='created_at', order_dir='desc' } = this.props.location.query

    this.setState({ order_by, order_dir }, () => this.loadPage())
  }

  componentWillReceiveProps(nextProps) {
    const { page:next, ...nextQuery } = nextProps.location.query
    const { page:prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  deleteHandlerFor = recommendedListing => event => {
    event.preventDefault()
    const confirmed = window.confirm(`Really delete this listing recommendation?`)
    if (!confirmed) {
      return
    }
    this.props.recommended_listings.delete(recommendedListing.id)
  }

  renderLoaded() {
    const { state:{ highlight=[] }={} } = this.props.location
    return (
      <div className="container padded recommended-listings">
        <div className="panel full padded">
          <h2 className="title">Listing Recommendations</h2>
          <div className="table-actions">
            <Link className="button" to={append('add')}>New Listing Recommendation</Link>
          </div>
          <div>
            <table className="zebra">
              <thead>
                <tr>
                  <OrderableTH query={this.state} field="mls_listing_id">MLS #</OrderableTH>
                  <th>Recommended To</th>
                  <th>Address</th>
                  <th>Price</th>
                  <th>Beds</th>
                  <th>Baths</th>
                  <th>Sqft</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Recommended By</th>
                  <OrderableTH query={this.state} field="created_at">Created</OrderableTH>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="padded">
                {this.props.recommended_listings.map(rl => (
                  <tr key={rl.id} className={classnames({ highlight: highlight.includes(rl.id) })}>
                    <td>{rl.mls_listing_id}</td>
                    <td className="center">{rl.lead_name}</td>
                    <td className="center">{rl.listing_details.address}</td>
                    <td className="center">{rl.listing_details.price}</td>
                    <td className="center">{rl.listing_details.bedrooms}</td>
                    <td className="center">{rl.listing_details.bathrooms}</td>
                    <td className="center">{rl.listing_details.sqft}</td>
                    <td className="center">{rl.listing_details.property_type}</td>
                    <td className="center">{rl.listing_details.status}</td>
                    <td className="center">{rl.user_name}</td>
                    <td className="center">{formatDate(rl.created_at)}</td>
                    <td className="center">
                      <DropdownMenu menuClass="website-page-actions" menuTitle={<Icon icon="bars" />}>
                        <a href={`${this.website.default_url}listing/${rl.listing_details.public_mls_id}/${rl.listing_details.public_mls_number}`} target="_blank">Preview Listing</a>
                        <a className="danger" to="#" onClick={this.deleteHandlerFor(rl)}>Delete</a>
                      </DropdownMenu>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <StorePagination store={this.props.recommended_listings} query={this.state} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/RecommendedListings/index.js